import {
  USERDETAILS,
  APPTOKEN,
  LOGINTOKEN,
  LOGOUT,
  LOGOUT_SUCCESS,
  VENDORDETAILS,
  CUSTOMERID,
  SET_LOCATION,
  ADD_PRODUCT_TO_STORE,
  ADDTO_CART,
  Remove_Item_FROM_CART,
  SET_MODAL_PROPERTIES,
  UPDATE_CART_QUANTITY,
  RESET_CART,
  GET_PRIMARY_ADDRESS,
  SET_DELIVERY_MODE,
  GET_SHOP_DETAILS,
  UPDATE_CART_TOTAL,
  GET_COUPON_CODE,
  GET_COUPON_AMOUNT,
  GET_SITE_SETTINGS,
  SET_FINAL_PAY_AMOUNT,
  SET_SITE_SETTINGS_CHARGES,
  SET_PLATFORM_FEES,
  SET_DELIVERY_PARTNER_FEES,
  SET_GST_CHARGES,
  SET_COUPON_AMOUNT,
  USERLOGINNUMBER,
} from "../constants/index";

export function getUserDetailsAction(userdetails) {
  return async (dispatch) => {
    try {
      const safeUserDetails = userdetails || {};
      console.log("dispatch userdetails", safeUserDetails);
      dispatch({ type: USERDETAILS, userData: safeUserDetails });
    } catch (e) {
      console.log("error on set", e);
    }
  };
}
export function getUserLoginNumber(mobileNumber) {
  return async (dispatch) => {
    try {
      console.log("dispatching mobile number", mobileNumber);
      dispatch({ type: USERLOGINNUMBER, userLoginNumber: { mobile_number: mobileNumber } });
    } catch (e) {
      console.log("error on set", e);
    }
  };
}
export function getAppToken(apptoken) {
  return async (dispatch) => {
    try {
      // console.log("dispatch apptoken", apptoken);
      dispatch({ type: APPTOKEN, apptoken: apptoken });
    } catch (e) {
      console.log("error on set", e);
    }
  };
}

export function getVendorDetails(vendordata) {
  return async (dispatch) => {
    try {
      console.log("dispatch vendordet", vendordata);
      dispatch({ type: VENDORDETAILS, vendordata: vendordata });
    } catch (e) {
      console.log("error on set", e);
    }
  };
}

export function getLoginToken(logintoken) {
  return async (dispatch) => {
    try {
      dispatch({ type: LOGINTOKEN, logintoken: logintoken });
    } catch (e) {
      console.log("error on set", e);
    }
  };
}

// export function getLogout() {
//   return async dispatch => {
//     try {
//       dispatch({type: LOGOUT});
//     } catch (e) {
//       console.log('error on set', e);
//     }
//   };
// }

export const getLogout = () => {
  console.log("Logout action dispatched");
  return async (dispatch) => {
    try {
      localStorage.clear();

      dispatch({ type: LOGOUT });

      dispatch({
        type: LOGOUT_SUCCESS,
        payload: { message: "Successfully logged out" },
      });
    } catch (error) {
      console.error("Logout error:", error);
    }
  };
};

export function getCustomerId(customerId) {
  return async (dispatch) => {
    try {
      console.log("dispatch customer id", customerId);
      dispatch({ type: CUSTOMERID, customerId: customerId });
    } catch (e) {
      console.log("error on set", e);
    }
  };
}

export function getLocation(latitude, longitude, changedAddress) {
  return async (dispatch) => {
    try {
      console.log("dispatching location:", latitude, longitude, changedAddress);

      dispatch({
        type: SET_LOCATION,
        payload: {
          latitude,
          longitude,
          changedAddress,
        },
      });
    } catch (e) {
      console.log("Error setting location:", e);
    }
  };
}
export function addProductToStore(productDetails) {
  return async (dispatch) => {
    try {
      console.log("dispatching cartDetails:", productDetails);

      dispatch({
        type: ADD_PRODUCT_TO_STORE,
        payload: productDetails,
      });
    } catch (e) {
      console.log("Error setting location:", e);
    }
  };
}
export function addToCart(cartDetails) {
  return async (dispatch) => {
    try {
      console.log("dispatching cartDetails:", cartDetails);

      dispatch({
        type: ADDTO_CART,
        payload: cartDetails,
      });
    } catch (e) {
      console.log("Error setting cartDetails:", e);
    }
  };
}

export function removeFromCart(itemDetails) {
  return async (dispatch) => {
    try {
      console.log("dispatching removing itemDetails:", itemDetails);

      dispatch({
        type: Remove_Item_FROM_CART,
        payload: itemDetails,
      });
    } catch (e) {
      console.log("Error setting itemDetails:", e);
    }
  };
}

export function updateCartTotal(total) {
  return async (dispatch) => {
    try {
      console.log("dispatching total:", total);

      dispatch({
        type: UPDATE_CART_TOTAL,
        payload: total,
      });
    } catch (e) {
      console.log("Error setting itemDetails:", e);
    }
  };
}

export function updateCartQuantity(vendor_product_id, quantity) {
  return async (dispatch) => {
    try {
      if (quantity < 1) return;
      dispatch({
        type: UPDATE_CART_QUANTITY,
        payload: {
          vendor_product_id,
          quantity,
        },
      });
    } catch (e) {
      console.log("Error in updating cart quantity:", e);
    }
  };
}
export function resetCart() {
  return async (dispatch) => {
    try {
      console.log("dispatching resetCart itemDetails:", resetCart);
      dispatch({
        type: RESET_CART,
      });
    } catch (e) {
      console.log("Error in resetCart:", e);
    }
  };
}

export function setModalProperties(modalProperties) {
  return async (dispatch) => {
    try {
      console.log("dispatching modalProperties:", modalProperties);

      dispatch({
        type: SET_MODAL_PROPERTIES,
        payload: modalProperties,
      });
    } catch (e) {
      console.log("Error setting location:", e);
    }
  };
}

export const getPrimaryAddress = (address) => {
  return async (dispatch) => {
    try {
      dispatch({
        type: GET_PRIMARY_ADDRESS,
        payload: address,
      });
    } catch (e) {
      console.log("Error setting address:", e);
    }
  };
};

export const disptchDeliveryMode = (mode) => {
  return async (dispatch) => {
    try {
      console.log("Dispatching delivery mode:", mode);
      dispatch({
        type: SET_DELIVERY_MODE,
        payload: mode,
      });
    } catch (e) {
      console.log("Error setting delivery mode:", e);
    }
  };
};

export const getShopdetails = (shopDetails) => {
  return async (dispatch) => {
    try {
      console.log("Dispatching Shop details:", shopDetails);
      dispatch({
        type: GET_SHOP_DETAILS,
        payload: shopDetails,
      });
    } catch (e) {
      console.log("Error getting shop details:", e);
    }
  };
};

export function getCouponCode(couponCode) {
  return {
    type: GET_COUPON_CODE,
    payload: couponCode,
  };
}

export function getCouponAmount(couponAmount) {
  return {
    type: GET_COUPON_AMOUNT,
    payload: couponAmount,
  };
}

export const getSiteSettingsData = (siteSettingsData) => ({
  type: GET_SITE_SETTINGS,
  payload: siteSettingsData,
});

export const setFinalPayAmount = (amount) => ({
  type: SET_FINAL_PAY_AMOUNT,
  payload: amount,
});

export const setSiteSettingsCharges = (charges) => ({
  type: SET_SITE_SETTINGS_CHARGES,
  payload: charges,
});

export const setPlatformFee = (platformFee) => ({
  type: SET_PLATFORM_FEES,
  payload: platformFee,
});

export const setDeliveryPartnerFee = (deliveryPartnerFee) => ({
  type: SET_DELIVERY_PARTNER_FEES,
  payload: deliveryPartnerFee,
});

export const setGstCharges = (gstCharges) => ({
  type: SET_GST_CHARGES,
  payload: gstCharges,
});

export const setcouponAmountData = (couponAmount) => ({
  type: SET_COUPON_AMOUNT,
  payload: couponAmount,
});
